module.exports = __webpack_public_path__ + "static/img/asher.1425624.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WhoAreWe/asher.png
// module id = AvRu
// module chunks = 0